import toast, { Toaster, ToastBar } from "react-hot-toast";

import ErrorMessage from "./ErrorMessage";

export default function ToastContainer() {
  return (
    <Toaster>
      {(t) => (
        <ToastBar toast={t} style={{ padding: "0px" }}>
          {({ icon, message }) =>
            t.type === "error" ? (
              <ErrorMessage
                message={message as string}
                onClose={() => toast.dismiss(t.id)}
              />
            ) : (
              message
            )
          }
        </ToastBar>
      )}
    </Toaster>
  );
}
